import { Model } from 'pinia-orm';

export default class InterviewTimeslot extends Model {

    static get entity () {
        return 'interview-timeslots'
    }

    static get primaryKey () {
        return ['interview_id', 'timeslots_id'];
    }


    static fields () {
        return {
            interview_id: this.attr(null),
            timeslots_id: this.attr(null),
        }
    }
}
